import type {FC, PropsWithChildren, Ref} from 'react';

import {useNavbarStyleConfig} from '../../theme-config';
import type {ButtonProps} from '../..';
import {Button} from '../..';

type Props = PropsWithChildren &
  Partial<Pick<ButtonProps, 'isDisabled' | 'isActive' | 'as'>> & {id: string; ref?: Ref<HTMLButtonElement>};

const NavbarButton: FC<Props> = ({children, isActive, id, ...props}) => {
  const style = useNavbarStyleConfig(`button`);
  return (
    <Button
      variant={`plain`}
      isActive={isActive}
      aria-current={isActive ? `page` : undefined}
      {...props}
      key={id}
      {...style}
    >
      {children}
    </Button>
  );
};

export default NavbarButton;
export type {Props as NavbarButtonProps};
